import type { SortMode } from './url-state';

export interface SortOptionModel {
  readonly key: SortMode;
  readonly label: string;
}

/**
 * One list for the desktop results-bar Select and the mobile-sheet Select
 * (WEB-668). WEB-1221: the default is date order, labelled Soonest. There is
 * no taste-ranked option — the server treated the old default key as date
 * order, so the label names that order. WEB-1228 (R2): no distance option —
 * the query is centered on the city, not on the reader.
 */
export function buildSortOptions(): readonly SortOptionModel[] {
  return [
    { key: 'date', label: 'Soonest' },
    { key: 'price', label: 'Price · low to high' },
  ];
}
